import { render, staticRenderFns } from "./UserIcons.vue?vue&type=template&id=11c9e592&scoped=true&"
import script from "./UserIcons.vue?vue&type=script&lang=js&"
export * from "./UserIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c9e592",
  null
  
)

export default component.exports